export default __webpack_public_path__ + "static/media/h5-bg3.468e7f74.png";